import {mixins} from "../app/mixin";

mixins.push({
    el: '.achievementsSlider',
    data: () => ({
        activeSlide: 0,
        leftSlide: 0,
        middleSlide: 1,
        rightSlide: 2,
        slideLength: window.achievementLength,
    }),
    methods: {
        nextSlide() {
            if (this.activeSlide < this.slideLength - 1) {
                if (this.activeSlide + 2 !== this.slideLength && this.activeSlide !== 0) {
                    this.leftSlide++;
                    this.middleSlide++;
                    this.rightSlide++;
                }

                this.activeSlide++
            }
        },
        previousSlide() {
            if (this.activeSlide > 0) {
                if (this.activeSlide - 1 !== 0 && this.activeSlide !== this.slideLength - 1) {
                    this.leftSlide--;
                    this.middleSlide--;
                    this.rightSlide--;
                }

                return this.activeSlide--
            }
        },
        setActiveSlide(slideId) {
            if (this.activeSlide !== slideId) {
                if (slideId < 2) {
                    this.leftSlide = 0;
                    this.middleSlide = 1;
                    this.rightSlide = 2;
                } else if (slideId > this.slideLength - 3) {
                    this.leftSlide = this.slideLength - 3;
                    this.middleSlide = this.slideLength - 3;
                    this.rightSlide = this.slideLength - 1;
                } else {
                    this.leftSlide = slideId - 1;
                    this.middleSlide = slideId;
                    this.rightSlide = slideId + 1;
                }

                this.activeSlide = slideId
            }
        },
    },
});